import { render, staticRenderFns } from "./GridGalleryProviderBuilder.vue?vue&type=template&id=0da63d94&"
import script from "./GridGalleryProviderBuilder.vue?vue&type=script&lang=js&"
export * from "./GridGalleryProviderBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports